import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AdminLayout from "../components/AdminLayout";
import { getTourFacets } from "@/lib/tours";

type LocationRow = { location: string; count: number };

export default function AdminDestinosPage() {
  const { t } = useTranslation("admin");
  const [rows, setRows] = useState<LocationRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getTourFacets()
      .then((f) => {
        if (cancelled) return;
        setRows([...f.locations].sort((a, b) => b.count - a.count));
      })
      .catch(() => { if (!cancelled) setRows([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <AdminLayout title={t("admin.dest.title")}>
      <p className="text-sm text-gray-500 mb-4">{t("admin.dest.desc")}</p>
      <div className="bg-white rounded-2xl border border-gray-100 p-5 md:p-6 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-100">
              <th className="text-left text-xs font-medium text-gray-400 py-3 pr-4">{t("admin.dest.destination")}</th>
              <th className="text-left text-xs font-medium text-gray-400 py-3">{t("admin.dest.activeTours")}</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={2} className="py-10 text-center text-gray-400">{t("admin.loading")}</td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan={2} className="py-10 text-center text-gray-400">{t("admin.dest.empty")}</td></tr>
            ) : (
              rows.map((d) => (
                <tr key={d.location} className="border-b border-gray-50 last:border-0">
                  <td className="py-3 pr-4 font-medium text-charcoal">{d.location}</td>
                  <td className="py-3 text-gray-600">{d.count}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
